/*
 * A crumb stays on one line and ellipsizes when the trail runs out of room.
 * Ancestors shrink faster than the current page (`flex-shrink: 4` vs `1`), so a
 * long trail truncates its history before it truncates where you are.
 */
.eds-breadcrumb-item {
  display: inline-flex;
  align-items: center;
  flex: 0 4 auto;
  min-width: 0;
  overflow: hidden;
}

.eds-breadcrumb-item[aria-current='page'] {
  flex-shrink: 1;
}

/*
 * The label — a Link, a Text, or the loading skeleton. `display: block` is what
 * makes `text-overflow` apply to the otherwise-inline label. Ellipsizing is the
 * last resort: Breadcrumb reads `scrollWidth` on these nodes to detect that the
 * trail no longer fits and collapses a crumb into the overflow menu instead.
 */
.eds-breadcrumb-item > * {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* The chevron is decorative and fixed-size: it must never shrink or clip. */
.eds-breadcrumb-separator {
  display: inline-flex;
  align-items: center;
  flex: none;
  color: var(--eds--color--fg-hint);
}

.eds-breadcrumb-item-skeleton {
  border-radius: var(--eds--radii-4);
  display: inline-block;
  height: var(--eds--typography--body-m-line-height);
  width: 96px;
  background-image: linear-gradient(
    90deg,
    var(--eds--color--bg-muted-soft) 25%,
    var(--eds--color--bg-muted-default) 37%,
    var(--eds--color--bg-muted-soft) 63%
  );
  background-size: 400% 100%;
  animation: eds-breadcrumb-item-shimmer 1.4s ease infinite;
}

@keyframes eds-breadcrumb-item-shimmer {
  0% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0 50%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .eds-breadcrumb-item-skeleton {
    animation: none;
  }
}
